import { render } from "./SignUpChoosePlan.vue?vue&type=template&id=6f530a14&scoped=true"
import script from "./SignUpChoosePlan.vue?vue&type=script&lang=js"
export * from "./SignUpChoosePlan.vue?vue&type=script&lang=js"

import "./SignUpChoosePlan.vue?vue&type=style&index=0&id=6f530a14&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f530a14"]])

export default __exports__